module.exports = __webpack_public_path__ + "img/main-share.34d526eb.svg";